{
  "title": "資格證明被退回怎麼辦",
  "description": "「學生資格驗證」狀態顯示「已退回」時的排查與重新上傳方式。",
  "headings": ["症狀", "最常見原因", "排查方式", "正常結果", "仍無法解決"],
  "symptom": "「學生資格驗證」頁面上「我的資格驗證狀態」顯示「已退回」，並附有一段退回原因文字。",
  "causes": [
    "上傳的文件類型不符合該場競賽接受的證明類型",
    "掃描或拍攝的文件內容模糊、不完整，主辦方無法辨識",
    "文件上的姓名、學校或系所等資訊與報名資料不一致",
    "上傳的文件已過期或已不是最新學期的在學證明"
  ],
  "diagnosis": [
    {
      "title": "Step 1",
      "description": "在「我的資格驗證狀態」卡片中閱讀「退回原因」欄位，這是該場競賽的主辦方人工審核時填寫的具體說明。"
    },
    {
      "title": "Step 2",
      "description": "對照退回原因，確認需要補正的是文件本身（重新掃描、換一份文件）還是填寫的學校／系所／學號等資料。"
    },
    {
      "title": "Step 3",
      "description": "確認要重新上傳的檔案格式為 PDF、PNG、JPG 或 JPEG，且單一檔案大小不超過 10 MB。"
    }
  ],
  "resolution": "點擊「重新上傳」展開表單，系統會自動帶入你先前填寫的證明類型、學校、系所、學號，只需要視退回原因修改對應欄位或更換檔案即可；送出後狀態會重新變回「審核中」，等待主辦方再次審核。詳細步驟請見「如何上傳學生資格驗證的在學證明」。",
  "stillStuck": ["競賽名稱", "退回原因的完整文字", "已重新上傳的次數", "Screenshot"],
  "doNotProvide": ["密碼", "驗證碼", "Token", "在學證明檔案本身"],
  "nextSteps": "資格驗證是由該場競賽的主辦方（競賽管理員）人工審核，並非平台系統自動判定，若對退回原因有疑問或認為判斷有誤，請直接聯絡該場競賽的主辦方，而非聯絡平台客服；此狀態不會影響你已完成的報名，可以在等待期間繼續進行報名與投稿相關的其他步驟。"
}
